import ListagemDeProduto from './listagem/store'
import DetalhesDoProduto from './detalhes/store'
import CarrinhoDeCompras from './carrinho/store'

export default {
    ListagemDeProduto,
    DetalhesDoProduto,
    CarrinhoDeCompras
}